import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

import enCommon from './locales/en/common.json'
import enErrors from './locales/en/errors.json'
import enValidation from './locales/en/validation.json'
import enAssets from './locales/en/assets.json'
import enContracts from './locales/en/contracts.json'
import enDocuments from './locales/en/documents.json'
import enUsers from './locales/en/users.json'
import enJobs from './locales/en/jobs.json'
import enIssues from './locales/en/issues.json'
import enSettings from './locales/en/settings.json'
import enData from './locales/en/data.json'
import enSearch from './locales/en/search.json'
import enDerivations from './locales/en/derivations.json'
import enFolders from './locales/en/folders.json'
import enProperties from './locales/en/properties.json'
import enTypes from './locales/en/types.json'
import enCompliance from './locales/en/compliance.json'
import enScenarios from './locales/en/scenarios.json'
import enCapex from './locales/en/capex.json'
import enFeedback from './locales/en/feedback.json'
import enAggregations from './locales/en/aggregations.json'
import enCompleteness from './locales/en/completeness.json'
import enMultiOrg from './locales/en/multi-org.json'
import enAdmin from './locales/en/admin.json'
import enSiteMap from './locales/en/site-map.json'
import enThematics from './locales/en/thematics.json'
import enCadastre from './locales/en/cadastre.json'
import enDataReliability from './locales/en/data-reliability.json'
import frCommon from './locales/fr/common.json'
import frErrors from './locales/fr/errors.json'
import frValidation from './locales/fr/validation.json'
import frAssets from './locales/fr/assets.json'
import frContracts from './locales/fr/contracts.json'
import frDocuments from './locales/fr/documents.json'
import frUsers from './locales/fr/users.json'
import frJobs from './locales/fr/jobs.json'
import frIssues from './locales/fr/issues.json'
import frSettings from './locales/fr/settings.json'
import frData from './locales/fr/data.json'
import frSearch from './locales/fr/search.json'
import frDerivations from './locales/fr/derivations.json'
import frFolders from './locales/fr/folders.json'
import frProperties from './locales/fr/properties.json'
import frTypes from './locales/fr/types.json'
import frCompliance from './locales/fr/compliance.json'
import frScenarios from './locales/fr/scenarios.json'
import frCapex from './locales/fr/capex.json'
import frFeedback from './locales/fr/feedback.json'
import frAggregations from './locales/fr/aggregations.json'
import frCompleteness from './locales/fr/completeness.json'
import frMultiOrg from './locales/fr/multi-org.json'
import frAdmin from './locales/fr/admin.json'
import frSiteMap from './locales/fr/site-map.json'
import frThematics from './locales/fr/thematics.json'
import frCadastre from './locales/fr/cadastre.json'
import frDataReliability from './locales/fr/data-reliability.json'
import enEngagement from './locales/en/engagement.json'
import frEngagement from './locales/fr/engagement.json'
import enFeatureFlags from './locales/en/feature-flags.json'
import frFeatureFlags from './locales/fr/feature-flags.json'
import enExpenses from './locales/en/expenses.json'
import frExpenses from './locales/fr/expenses.json'
import enInterventions from './locales/en/interventions.json'
import frInterventions from './locales/fr/interventions.json'
import enGraph from './locales/en/graph.json'
import enAuth from './locales/en/auth.json'
import frGraph from './locales/fr/graph.json'
import frAuth from './locales/fr/auth.json'
import enImports from './locales/en/imports.json'
import enWorkOrders from './locales/en/workorders.json'
import enLabels from './locales/en/labels.json'
import frImports from './locales/fr/imports.json'
import frWorkOrders from './locales/fr/workorders.json'
import frLabels from './locales/fr/labels.json'
import enBenchmark from './locales/en/benchmark.json'
import enAssemblies from './locales/en/assemblies.json'
import enLeases from './locales/en/leases.json'
import enListings from './locales/en/listings.json'
import enWebhooks from './locales/en/webhooks.json'
import enRentalApplications from './locales/en/rentalApplications.json'
import enViewings from './locales/en/viewings.json'
import enDataProtection from './locales/en/data-protection.json'
import enAgentRuns from './locales/en/agent-runs.json'
import enAssistant from './locales/en/assistant.json'
import enSignatures from './locales/en/signatures.json'
import enKnowledge from './locales/en/knowledge.json'
import enCampaigns from './locales/en/campaigns.json'
import enBilling from './locales/en/billing.json'
import enArchive from './locales/en/archive.json'
import enBallots from './locales/en/ballots.json'
import frBenchmark from './locales/fr/benchmark.json'
import frAssemblies from './locales/fr/assemblies.json'
import frLeases from './locales/fr/leases.json'
import frListings from './locales/fr/listings.json'
import frWebhooks from './locales/fr/webhooks.json'
import frRentalApplications from './locales/fr/rentalApplications.json'
import frViewings from './locales/fr/viewings.json'
import frDataProtection from './locales/fr/data-protection.json'
import frAgentRuns from './locales/fr/agent-runs.json'
import frAssistant from './locales/fr/assistant.json'
import frSignatures from './locales/fr/signatures.json'
import frKnowledge from './locales/fr/knowledge.json'
import frCampaigns from './locales/fr/campaigns.json'
import frBilling from './locales/fr/billing.json'
import frArchive from './locales/fr/archive.json'
import frBallots from './locales/fr/ballots.json'
import enConversations from './locales/en/conversations.json'
import enGroupSteering from './locales/en/group-steering.json'
import frConversations from './locales/fr/conversations.json'
import frGroupSteering from './locales/fr/group-steering.json'
import enAccess from './locales/en/access.json'
import enRoles from './locales/en/roles.json'
import frAccess from './locales/fr/access.json'
import frRoles from './locales/fr/roles.json'
import enLegal from './locales/en/legal.json'
import enReports from './locales/en/reports.json'
import frLegal from './locales/fr/legal.json'
import frReports from './locales/fr/reports.json'

export const defaultNS = 'common'
export const resources = {
  en: {
    common: enCommon,
    errors: enErrors,
    validation: enValidation,
    assets: enAssets,
    contracts: enContracts,
    documents: enDocuments,
    users: enUsers,
    jobs: enJobs,
    issues: enIssues,
    settings: enSettings,
    data: enData,
    search: enSearch,
    derivations: enDerivations,
    folders: enFolders,
    properties: enProperties,
    types: enTypes,
    compliance: enCompliance,
    scenarios: enScenarios,
    capex: enCapex,
    feedback: enFeedback,
    aggregations: enAggregations,
    completeness: enCompleteness,
    'multi-org': enMultiOrg,
    admin: enAdmin,
    siteMap: enSiteMap,
    thematics: enThematics,
    cadastre: enCadastre,
    'data-reliability': enDataReliability,
    engagement: enEngagement,
    'feature-flags': enFeatureFlags,
    expenses: enExpenses,
    interventions: enInterventions,
    graph: enGraph,
    auth: enAuth,
    imports: enImports,
    workorders: enWorkOrders,
    labels: enLabels,
    benchmark: enBenchmark,
    assemblies: enAssemblies,
    leases: enLeases,
    listings: enListings,
    webhooks: enWebhooks,
    rentalApplications: enRentalApplications,
    viewings: enViewings,
    'data-protection': enDataProtection,
    'agent-runs': enAgentRuns,
    assistant: enAssistant,
    signatures: enSignatures,
    knowledge: enKnowledge,
    campaigns: enCampaigns,
    billing: enBilling,
    archive: enArchive,
    ballots: enBallots,
    roles: enRoles,
    access: enAccess,
    conversations: enConversations,
    'group-steering': enGroupSteering,
    legal: enLegal,
    reports: enReports,
  },
  fr: {
    common: frCommon,
    errors: frErrors,
    validation: frValidation,
    assets: frAssets,
    contracts: frContracts,
    documents: frDocuments,
    users: frUsers,
    jobs: frJobs,
    issues: frIssues,
    settings: frSettings,
    data: frData,
    search: frSearch,
    derivations: frDerivations,
    folders: frFolders,
    properties: frProperties,
    types: frTypes,
    compliance: frCompliance,
    scenarios: frScenarios,
    capex: frCapex,
    feedback: frFeedback,
    aggregations: frAggregations,
    completeness: frCompleteness,
    'multi-org': frMultiOrg,
    admin: frAdmin,
    siteMap: frSiteMap,
    thematics: frThematics,
    cadastre: frCadastre,
    'data-reliability': frDataReliability,
    engagement: frEngagement,
    'feature-flags': frFeatureFlags,
    expenses: frExpenses,
    interventions: frInterventions,
    graph: frGraph,
    auth: frAuth,
    imports: frImports,
    workorders: frWorkOrders,
    labels: frLabels,
    benchmark: frBenchmark,
    assemblies: frAssemblies,
    leases: frLeases,
    listings: frListings,
    webhooks: frWebhooks,
    rentalApplications: frRentalApplications,
    viewings: frViewings,
    'data-protection': frDataProtection,
    'agent-runs': frAgentRuns,
    assistant: frAssistant,
    signatures: frSignatures,
    knowledge: frKnowledge,
    campaigns: frCampaigns,
    billing: frBilling,
    archive: frArchive,
    ballots: frBallots,
    roles: frRoles,
    access: frAccess,
    conversations: frConversations,
    'group-steering': frGroupSteering,
    legal: frLegal,
    reports: frReports,
  },
} as const

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    defaultNS,
    fallbackLng: 'en',
    supportedLngs: ['en', 'fr'],
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['navigator'],
      caches: [],
    },
  })

export default i18n
